import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Box
} from '@mui/material';

import FavoriteIcon from '@mui/icons-material/Favorite';
import OpacityIcon from '@mui/icons-material/Opacity';
import AirIcon from '@mui/icons-material/Air';
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';

export default function ChronicConditionsSection({
  onHypertensionUpload,
  onDiabetesUpload,
  onCOPDUpload,
  onAsthmaUpload,
  onCHFUpload,
  onAFibUpload
}) {
  const handleFileUpload = (callback) => (e) => {
    const file = e.target.files[0];
    if (file?.type === 'text/plain') {
      const reader = new FileReader();
      reader.onload = (e) => callback(e.target.result);
      reader.readAsText(file);
    }
  };

  const downloadTemplate = (filename, content) => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  const conditions = [
    {
      label: 'Hypertension',
      icon: <FavoriteIcon />,
      handler: onHypertensionUpload,
      filename: 'hypertension_template.txt',
      content: 'Diagnosis date: 2020\nAverage BP: 140/90\nMedication: Amlodipine'
    },
    {
      label: 'Diabetes',
      icon: <OpacityIcon />,
      handler: onDiabetesUpload,
      filename: 'diabetes_template.txt',
      content: 'Type: 2\nDiagnosis date: 2018\nHbA1c: 7.2%\nTreatment: Metformin'
    },
    {
      label: 'COPD',
      icon: <AirIcon />,
      handler: onCOPDUpload,
      filename: 'copd_template.txt',
      content: 'FEV1: 55%\nSymptoms: Dyspnea, chronic cough\nTreatment: Tiotropium'
    },
    {
      label: 'Asthma',
      icon: <CoronavirusIcon />,
      handler: onAsthmaUpload,
      filename: 'asthma_template.txt',
      content: 'Type: Moderate persistent asthma\nCurrent control: Partial\nInhaler: Salmeterol/Fluticasone'
    },
    {
      label: 'Congestive Heart Failure (CHF)',
      icon: <TroubleshootIcon />,
      handler: onCHFUpload,
      filename: 'chf_template.txt',
      content: 'Ejection fraction: 35%\nSymptoms: Fatigue, dyspnea\nTreatment: Enalapril, furosemide'
    },
    {
      label: 'Atrial Fibrillation',
      icon: <ElectricBoltIcon />,
      handler: onAFibUpload,
      filename: 'atrial_fibrillation_template.txt',
      content: 'Diagnosis: Permanent\nAnticoagulant: Apixaban\nRate controlled: Yes'
    }
  ];

  return (
    <Card sx={{ mb: 6 }}>
      <CardHeader title="Specific Chronic Conditions" sx={{ backgroundColor: '#f5f5f5' }} />
      <CardContent>
        <Grid container spacing={4}>
          {conditions.map((cond, idx) => (
            <Grid item xs={12} sm={6} key={idx}>
              <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
                {cond.icon} {cond.label}
              </Typography>
              <Box mt={1} display="flex" gap={2}>
                <Button variant="outlined" component="label">
                  Upload .txt file
                  <input type="file" hidden onChange={handleFileUpload(cond.handler)} accept=".txt" />
                </Button>
                <Button
                  variant="text"
                  onClick={() => downloadTemplate(cond.filename, cond.content)}
                >
                  Download template
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}
